import styled from "styled-components";
import { BORDER_COLORS, COLORS, TEXT_COLORS } from "../../constants/design/colors";
import { FONT_SIZE } from "../../constants/design/fontSize";
import { SPACING, COMPONENTS } from "../../constants/design/spacing";

export const HeaderRow = styled.div`
  border-bottom: 1px solid ${BORDER_COLORS.two};
`;

export const MobileHeaderRow = styled.div`
  display: flex;
  height: ${COMPONENTS.header.mobile}px;
  justify-content: center;

  > a {
    margin: auto ${SPACING.two}px;
  }
`;

export const MainHeaderWrapper = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  border-bottom: 1px solid ${BORDER_COLORS.two};
  padding: 0 ${SPACING.three}px;
  min-height: ${COMPONENTS.header.main}px;
`;

export const LogoBlock = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  > a {
    display: flex;
    align-items: center;
  }
`;

export const Divider = styled.div<{
  height?: string;
  horizontalMargin?: string;
}>`
  background-color: ${COLORS.white.three};
  width: 1px;
  height: ${({ height }) => height ?? "unset"};

  margin-left: ${({ horizontalMargin }) => horizontalMargin || `${SPACING.twoHalf}px`};
  margin-right: ${({ horizontalMargin }) => horizontalMargin || `${SPACING.twoHalf}px`};
`;

export const LeftHeaderWrapper = styled.div`
  font-size: ${FONT_SIZE.two};
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  min-width: 0;

  a {
    color: ${TEXT_COLORS.two};
    text-decoration: none;
  }
`;

export const RightHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  font-size: ${FONT_SIZE.two};

  > button {
    min-height: 42px;
  }
`;

export const NotificationButton = styled.button`
  width: 32px;
  height: 32px;
  padding: 0;
`;

export const LinkText = styled.span<{ isActive: boolean }>`
  transition: 0.2s ease-in-out;
  color: ${(props) => (props.isActive ? TEXT_COLORS.one : TEXT_COLORS.three)};

  &:hover {
    color: ${TEXT_COLORS.one};
  }
`;

export const NavigationRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  row-gap: ${SPACING.one}px;
  column-gap: ${SPACING.three}px;
  padding: ${SPACING.one}px 0;

  a {
    color: ${TEXT_COLORS.two};
    text-decoration: none;
  }
`;

export const SectionLabel = styled.span`
  font-size: ${FONT_SIZE.one};
  font-weight: 600;
  color: ${TEXT_COLORS.two};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-right: ${SPACING.one}px;
  padding-left: ${SPACING.two}px;
`;
